/* narin. — custom "Buy it now": adds the selected variant, then goes to checkout. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-narin-buynow]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('.product__info-container') || document;
    var form = scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!form) {
      window.location.href = root + 'checkout';
      return;
    }
    btn.setAttribute('disabled', '');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        btn.removeAttribute('disabled');
        btn.classList.remove('is-loading');
        // fallback: normal submit (adds to cart)
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
  });
})();
